
import {
  MessageCircle, Mail, MapPin, Phone, Globe,
  Users, Star, Sparkles, Heart, Award, Shield, Clock, CheckCircle, Zap, Target, type LucideIcon,
} from 'lucide-react';
import { usePageContent } from '@/hooks/usePageContent';

const BADGE_ICON_MAP: Record<string, LucideIcon> = {
  MessageCircle, Mail, MapPin, Phone, Globe,
  Users, Star, Sparkles, Heart, Award, Shield, Clock, CheckCircle, Zap, Target,
};

interface BadgeItem { label: string; icon: string; }

const DEFAULT_BADGES: BadgeItem[] = [
  { label: 'WhatsApp Disponível', icon: 'MessageCircle' },
  { label: 'Resposta em 24h Úteis', icon: 'Mail' },
  { label: '3 Consultórios em SP', icon: 'MapPin' },
];

function parseBadges(raw: any[]): BadgeItem[] {
  return raw.map(b => typeof b === 'string' ? { label: b, icon: 'Star' } : b);
}

export function ContactHero() {
  const { getText, get } = usePageContent('contact');

  const title       = getText('hero', 'title',       'Entre em Contato');
  const description = getText('hero', 'description', 'Estou aqui para ajudar você em sua jornada de transformação. Escolha o canal mais conveniente e vamos conversar!');
  const rawBadges   = get('hero', 'badges')?.content_value?.items as any[] | undefined;
  const badges      = rawBadges ? parseBadges(rawBadges) : DEFAULT_BADGES;

  return (
    <section className="bg-brand-primary py-14 sm:py-20">
      <div className="container mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 text-white/90 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wide uppercase">
          <MessageCircle className="w-3.5 h-3.5" />
          Fale Conosco
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-primary mb-4 leading-tight">
          {title}
        </h1>
        <p className="text-white/75 text-base sm:text-lg max-w-2xl mx-auto font-primary">
          {description}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          {badges.map((badge, i) => {
            const Icon = BADGE_ICON_MAP[badge.icon] || Star;
            return (
              <div key={i} className="flex items-center gap-2 bg-white/10 text-white text-sm font-medium px-4 py-2 rounded-full">
                <Icon className="w-4 h-4 text-white/70" />
                {badge.label}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
